<template>
  <main>
    <div class>
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t("title.addSchool") }}</h3>
            </template>

            <template v-slot:right-element>
              <a
                class="btn btn-outline-primary button"
                :disabled="loading"
                @click="$router.go(-1)"
              >
                <i class="arrow left" />
                {{ $t("button.retour") }}
              </a>
            </template>
          </TopTemplate>
          <div v-if="is_created" class="alert alert-success" role="alert">
            {{ $t("info.addSchool") }}
          </div>
          <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
            <div class="spinner-border text-info" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <form
            v-if="!loading"
            class="add-student"
            @submit.prevent="onSubmitCreateSchool"
            novalidate
          >
            <div class="general-info">
              <div @click="toggleAccInfo()" class="accordSid">
                <h3>{{ $t("title.infoSchool") }}</h3>
                <div class="icons-wrapper">
                  <i v-if="show1" class="icon-Minus" />
                  <i v-else class="icon-Add" />
                </div>
              </div>
              <div v-if="show1" class="panel">
                <div class="row">
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="simple-input">
                          <label class="label">
                            {{ $t("school.nameschool") }}
                            <sup>*</sup>
                          </label>
                          <div>
                            <input
                              v-model="ecole.name"
                              type="text"
                              class="form-control"
                              :class="v$.ecole.name.$error ? 'is-invalid' : ''"
                            />
                            <span
                              v-if="v$.ecole.name.$error"
                              class="invalid-feedback"
                              >{{ v$.ecole.name.$errors[0].$message }}</span
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="simple-input">
                          <label class="label">
                            {{ $t("school.email") }}
                            <sup>*</sup>
                          </label>
                          <div>
                            <input
                              v-model="ecole.email"
                              type="text"
                              class="form-control"
                              :class="v$.ecole.email.$error ? 'is-invalid' : ''"
                            />
                            <span
                              v-if="v$.ecole.email.$error"
                              class="invalid-feedback"
                              >{{ v$.ecole.email.$errors[0].$message }}</span
                            >
                            <span v-if="emailSchoolError" class="text-danger">{{ $t('error.uniqueEmail') }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="simple-input-gender simple-input">
                          <label class="label"
                            >{{ $t("school.gouvernorat") }} <sup>*</sup></label
                          >
                          <div>
                            <v-select
                              v-model="ecole.gouvernorat_id"
                              :options="governorates"
                              label="governorate"
                              :searchable="true"
                              :reduce="(option) => option"
                              class="form-control"
                              @update:modelValue="ChangeGouvernorat($event)"
                            >
                              <template
                                #no-options="{ search, searching, loading }"
                                >{{ $t("info.noResult") }}</template
                              >
                            </v-select>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="simple-input-gender simple-input">
                          <label class="label"
                            >{{ $t("school.delegation") }} <sup>*</sup></label
                          >
                          <div>
                            <v-select
                              v-model="ecole.delegation_id"
                              :options="delegations"
                              label="delegation"
                              :searchable="true"
                              :disabled="!ecole.gouvernorat_id"
                              :reduce="(option) => option.id"
                              class="form-control"
                              @update:modelValue="ChangeDeleg($event)"
                              :class="{ 'is-invalid': v$.ecole.delegation_id.$error }"
                            >
                              <template
                                #no-options="{ search, searching, loading }"
                                >{{ $t("info.noResult") }}</template
                              >
                            </v-select>
                            <span
                              v-if="v$.ecole.delegation_id.$error"
                              class="invalid-feedback"
                              >{{ v$.ecole.delegation_id.$errors[0].$message }}</span
                            >

                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="simple-input">
                              <label class="label">{{
                                $t("school.address")
                              }}</label>
                              <div>
                                <input v-model="ecole.adresse" type="text" />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="simple-input">
                              <label class="label">{{
                                $t("school.code")
                              }}</label>
                              <div>
                                <input
                                  v-model="ecole.code_postale"
                                  oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\+/g, '$1');"
                                  type="tel"
                                  maxlength="4"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="simple-input">
                              <label class="label">{{
                                $t("school.phone")
                              }}</label>
                              <div>
                                <input
                                  v-model="ecole.phone"
                                  oninput="this.value = this.value.replace(/[^0-9+]/g, '').replace(/(\..*)\+/g, '$1');"
                                  type="tel"
                                  maxlength="8"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- accept="image/png, image/jpeg" -->
                  <div class="col-md-2">
                    <div class="avatar" :class="{ redfront: acceptedFormat }">
                      <div class="avatar_edit" :class="{ back: ecole.photo }">
                        <i class="ri-edit-2-line" />
                        <label for="studentPhoto">
                          <i v-if="!ecole.photo" class="ri-edit-2-line" />
                        </label>
                        <i
                          v-if="ecole.photo"
                          class="icon-Add"
                          @click="onImageReset()"
                        />
                      </div>
                      <input
                        v-if="!ecole.photo"
                        id="studentPhoto"
                        ref="file"
                        class="custom-file-input"
                        type="file"
                        name="photo"
                        accept="image/<sup>*</sup>"
                        v-on:change="onImageChange"
                      />
                      <img
                        v-if="ecole.photo"
                        :src="ecole.photo"
                        :class="{ 'd-block': ecole.photo }"
                        class="img-thumbnail"
                      />
                      <label v-else for="studentPhoto">
                        <img
                          src="../../../assets/icons/avatar.svg"
                          alt="avatar"
                          class="avator"
                        />
                      </label>
                    </div>
                    <!--  <span
                      v-show="acceptedFormat"
                      class="indice indiceFormat"
                    >Le fichier reçu dépasse les 2 Mo !</span> -->
                    <span class="indice">{{ $t("info.formatPhoto") }}</span>
                    <span class="indice">{{ $t("info.sizeImage") }}</span>
                    <span v-if="errorDocSize" class="indice errorSizeDoc">{{
                      $t("error.errorTailleMsg")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="general-info duplicator">
              <div class="accordSid" @click="toggleAccSco()">
                <h3>{{ $t("title.adminInfo") }}</h3>
                <div class="icons-wrapper">
                  <i v-if="show5" class="icon-Minus" />
                  <i v-else class="icon-Add" />
                </div>
              </div>

              <div v-if="show5" class="panel">
                <div v-for="(input, index) in array" :key="index" class="row">
                  <div class="simple-input simple-select col-md-3 col-6">
                    <label class="label">
                      {{ $t("school.firstName") }}
                      <sup>*</sup>
                    </label>
                    <input
                      v-model="input.last_name"
                      class="form-control"
                      type="text"
                      :class="
                        v$.array.$dirty &&
                        v$.array.$each.$response.$errors[index].last_name
                          .length > 0
                          ? 'is-invalid'
                          : ''
                      "
                    />
                    <span
                      v-if="
                        v$.array.$dirty &&
                        v$.array.$each.$response.$errors[index].last_name
                          .length > 0
                      "
                      class="invalid-feedback"
                      >{{
                        v$.array.$each.$response.$errors[index].last_name[0]
                          .$message
                      }}</span
                    >
                  </div>

                  <div class="simple-input col-md-3 col-6">
                    <label class="label">
                      {{ $t("school.lastName") }}
                      <sup>*</sup>
                    </label>
                    <div>
                      <input
                        v-model="input.first_name"
                        class="form-control"
                        type="text"
                        :class="
                          v$.array.$dirty &&
                          v$.array.$each.$response.$errors[index].first_name
                            .length > 0
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <span
                        v-if="
                          v$.array.$dirty &&
                          v$.array.$each.$response.$errors[index].first_name
                            .length > 0
                        "
                        class="invalid-feedback"
                        >{{
                          v$.array.$each.$response.$errors[index].first_name[0]
                            .$message
                        }}</span
                      >
                    </div>
                  </div>

                  <div class="simple-input last-input-modif col-md-3 col-6">
                    <label class="label">
                      {{ $t("school.email") }}
                      <sup>*</sup>
                    </label>
                    <div>
                      <input
                        v-model="input.email"
                        class="form-control"
                        type="text"
                        :class="
                          v$.array.$dirty &&
                          v$.array.$each.$response.$errors[index].email.length >
                            0
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <span
                        v-if="
                          v$.array.$dirty &&
                          v$.array.$each.$response.$errors[index].email.length >
                            0
                        "
                        class="invalid-feedback"
                        >{{
                          v$.array.$each.$response.$errors[index].email[0]
                            .$message
                        }}</span
                      >
                      <span v-if="input.messageErrorEmail" class="text-danger">{{ $t('error.uniqueEmail') }}</span>
                    </div>
                  </div>
                  <div class="simple-input last-input-modif col-md-3 col-6">
                    <label class="label"
                      >{{ $t("school.phone") }} <sup>*</sup></label
                    >
                    <div>
                      <input
                        v-model="input.phone"
                        oninput="this.value = this.value.replace(/[^0-9+]/g, '').replace(/(\..*)\+/g, '$1');"
                        type="tel"
                        maxlength="8"
                        class="form-control"
                        :class="
                          v$.array.$dirty &&
                          v$.array.$each.$response.$errors[index].phone.length >
                            0
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <span
                        v-if="
                          v$.array.$dirty &&
                          v$.array.$each.$response.$errors[index].phone.length >
                            0
                        "
                        class="invalid-feedback"
                        >{{
                          v$.array.$each.$response.$errors[index].phone[0]
                            .$message
                        }}</span
                      >
                      <span v-if="input.messageErrorPhone" class="text-danger">{{ $t('error.uniquePhone') }}</span>
                    </div>
                    <div class="btn-add">
                      <i
                        v-if="array.length > 1"
                        class="icon-trash ck-remove"
                        @click="removeItem(index)"
                      />
                    </div>
                  </div>

                  <div
                    v-if="index === array.length - 1"
                    class="col-md-12 btn-add"
                  >
                    <button
                      class="btn btn-outline-primary button"
                      @click="pushToArray()"
                    >
                      <i class="icon-Add" /> {{ $t("button.addAdmin") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="general-info duplicator">
              <div class="accordSid" @click="toggleAccMod()">
                <h3>Gestion des modules</h3>
                <div class="icons-wrapper">
                  <i v-if="show6" class="icon-Minus" />
                  <i v-else class="icon-Add" />
                </div>
              </div>
              <div v-if="show6" class="panel">
                <div class="row items-wrapper">
                  <div
                    v-for="module in modules_list"
                    :key="module.id"
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12 pointer"
                    @click="
                      checkItem(module.id),
                        (module.is_checked = !module.is_checked)
                    "
                  >
                    <div
                      class="matiere-item"
                      :class="
                        module.is_checked === true ? 'matiere-background' : ''
                      "
                    >
                      <span>{{ module.name }}</span>
                      <label class="container-checkbox">
                        <input
                          v-model="selected"
                          type="checkbox"
                          :value="module.id"
                        />
                        <span
                          class="checkmark"
                          :class="
                            module.is_checked === true ? 'chekedchek' : ''
                          "
                        ></span>
                      </label>
                    </div>
                  </div>
                </div>
                
              </div>
            </div><div class="general-info duplicator">
              <div class="accordSid" @click="toggleAccGat()">
                <h3>{{ $t("title.niveauEtude") }}</h3>
                <div class="icons-wrapper">
                  <i v-if="show7" class="icon-Minus" />
                  <i v-else class="icon-Add" />
                </div>
              </div>
              <div v-if="show7" class="panel">
               
                <div class="row items-wrapper">
                  <div
                    v-for="gategorie in gategories_list"
                    :key="gategorie.id"
                    class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12 pointer"
                    @click="
                      checkItemGat(gategorie.id),
                        (gategorie.is_checked = !gategorie.is_checked)
                    "
                  >
                    <div
                      class="matiere-item"
                      :class="
                        gategorie.is_checked === true ? 'matiere-background' : ''
                      "
                    >
                      <span>{{ gategorie.name }}</span>
                      <label class="container-checkbox">
                        <input
                          v-model="selectedGat"
                          type="checkbox"
                          :value="gategorie.id"
                        />
                        <span
                          class="checkmark"
                          :class="
                            gategorie.is_checked === true ? 'chekedchek' : ''
                          "
                        ></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 buttons">
              <div class="button-right d-flex justify-content-end mb-4">
                <button
                  type="submit"
                  class="btn button btn-primary"
                  :disabled="loading"
                >
                  <i class="icon-Add" />
                  {{ $t("button.addCompte") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../../components/toptemplate/TopTemplate.vue";
import vSelect from "vue-select";
import Form from "../../../core/Form";
import useValidate from "@vuelidate/core";
import { required, helpers, email } from "@vuelidate/validators";
import SituationsService from "../../../services/situations.service";
import SchoolService from "../../../services/school.service";
import moment from "moment";
import _ from "lodash";
const SIZE_IMAGE = 2;
//const isPhone = helpers.regex(/[\d]/); //phone valid

export default {
  name: "AddEcole",
  components: {
    TopTemplate,
    "v-select": vSelect,
  },
  setup() {
    // In case of a range picker, you'll receive [Date, Date]
    const format = (due_date) => {
      const day = due_date.getDate();
      const month = due_date.getMonth() + 1;
      const year = due_date.getFullYear();
      if (day <= 9) {
        return `0${day}/0${month}/${year}`;
      } else if (day > 9) {
        return `${day}/${month}/${year}`;
      }
      if (month <= 9) {
        return `${day}/0${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    };

    return {
      format,
    };
  },
  data() {
    return {
      v$: useValidate(),
      delegations: [],
      governorates: [],
      selectedGouv: null,
      selectedDeleg: null,
      errorDocSize: false,
      messageErrorEmail: false,
      messageErrorPhone: false,
      schoolid: null,
      array: [
        {
          id: "",
          last_name: "",
          first_name: "",
          email: "",
          phone: "",
          messageErrorEmail:false,
          messageErrorPhone:false
        },
      ],
      //  administrator: [
      //     {
      //       last_name: "",
      //       first_name: "",
      //       email:"",
      //       phone:""
      //     }
      //   ],
      ecole: new Form({
        name: "",
        email: "",
        phone: "",
        adresse: "",
        photo: "",
        code_postale: null,
        gouvernorat_id: null,
        delegation_id: null,
      }),
      loading: false,
      is_created: false,
      emailSchoolError:false,
      acceptedFormat: false,
      modules: [],
      modules_list: [],
      gategories_list:[],
      selected: [],
      selectedGat: [],
      show1: true,
      show5: true,
      show6: true,
      show7: true,
    };
  },
  validations() {
    return {
      array: {
        $each: helpers.forEach({
          last_name: {
            required: helpers.withMessage(
              this.$t("validation.required"),
              required
            ),
          },
          first_name: {
            required: helpers.withMessage(
              this.$t("validation.required"),
              required
            ),
          },
          email: {
            email: helpers.withMessage(this.$t("validation.email"), email),
            required: helpers.withMessage(
              this.$t("validation.required"),
              required
            ),
          },
          phone: {
            required: helpers.withMessage(
              this.$t("validation.required"),
              required
            ),
          },
        }),
      },

      ecole: {
        name: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },
        delegation_id: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },

        email: {
          email: helpers.withMessage(this.$t("validation.email"), email),
          $autoDirty: false,
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },
      },
    };
  },

  mounted() {
    this.getModules();
    this.getGategories();
    /* this.ListSituationsStudent();
    this.ListSituationsParent();
     */
    this.getGouvernorat();
  },

  methods: {
    checkItem(id) {
      if (this.selected.includes(id)) {
        this.selected = this.selected.filter((el) => el != id);
      } else {
        this.selected.push(id);
      }
    },
    checkItemGat(id) {
      if (this.selectedGat.includes(id)) {
        this.selectedGat = this.selectedGat.filter((el) => el != id);
      } else {
        this.selectedGat.push(id);
      }
    },
    checkFilesSize: _.throttle(function (file) {
      if (!file) {
        this.errorDocSize = false;
      }
      this.errorDocSize = file.size / 1024 / 1024 > SIZE_IMAGE;

    }, 300),
    ChangeGouvernorat(e) {
      this.ecole.delegation_id = null;
      if (e) {
        this.selectedGouv = e.id;
        this.delegations = e.delegation;
      }
    },
    ChangeDeleg(e) {
      if (e) {
        this.selectedDeleg = e;
      }
    },
    getDelegations(params) {
      this.loading = true;
      SchoolService.getDelegations({
        params: {
          governorat_id: params,
        },
      })
        .then((response) => {
          this.selectedClass = null;
          this.delegations = _.orderBy(
            response.data.data[0].delegation,
            "delegation"
          );
          this.governorates = _.orderBy(
            response.data.data[0].delegation,
            "governorate"
          );
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getModules(params) {
      this.loading = true;
      SchoolService.getAllModules({
        params: {},
      })
        .then((response) => {
          this.modules_list = response.data.data;
          this.modules_list = _.orderBy(response.data.data, "name");
          this.modules_list.forEach((element) => {
            if (element.is_checked === true) {
              this.selected.push(element.id);
            }
          });
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getGategories(params) {
      this.loading = true;
      SchoolService.getAllGategories({
        params: {},
      })
        .then((response) => {
          this.gategories_list = response.data.data;
          this.gategories_list = _.orderBy(response.data.data, "name");
          this.gategories_list.forEach((element) => {
            if (element.is_checked === true) {
              this.selectedGat.push(element.id);
            }
          });
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getGouvernorat() {
      this.loading = true;
      SchoolService.getGouvernorat({
        params: {
          governorat_id: this.selectedGouv,
        },
      })
        .then((response) => {
          this.selectedClass = null;
          this.governorates = _.orderBy(
            response.data.governorates,
            "governorate"
          );
          this.delegations = _.orderBy(response.data.delegations, "delegation");
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },

    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    pushToArray() {
      this.array.push({
        id: "",
        last_name: "",
        first_name: "",
        email: "",
        phone: "",
      });
    },
    resetFildes() {
      this.ecole.name = "";
      this.ecole.email = "";
      this.ecole.phone = "";
      this.ecole.adresse = "";
      this.ecole.photo = "";
      this.ecole.code_postale = null;
      this.ecole.gouvernorat_id = null;
      this.ecole.delegation_id = null;
      this.array.forEach((ad) => {
        (ad.id = ""),
        (ad.last_name = ""),
        (ad.first_name = ""),
        (ad.email = ""),
        (ad.phone = "");
      });
    },

    formatByDate: _.debounce(function () {
      if (this.student.birthday != null) {
        this.student.birthday = this.dateTime(this.student.birthday);
      }
    }, 200),

    removeItem(i) {
      this.array = this.array.filter((el, index) => index != i);
    },
    toggleAccInfo() {
      this.show1 = !this.show1;
    },

    toggleAccSco() {
      this.show5 = !this.show5;
    },
    toggleAccMod() {
      this.show6 = !this.show6;
    },
    toggleAccGat() {
      this.show7 = !this.show7;
    },
    onSubmitCreateSchool() {
      this.v$.$validate(); // checks all inputs
      // this.$nextTick(() => {
      //   if (document.querySelector(".is-invalid")) {
      //     //this.candidature.edit_candidat = true;
      //     this.show1 = true;
      //     this.show2 = true;
      //     this.show3 = true;
      //     this.show4 = true;
      //     this.show5 = true;
      //     this.show6 = true;
      //     let domRect = document
      //       .querySelector(".is-invalid")
      //       .getBoundingClientRect();
      //     window.scrollTo({
      //       left: domRect.left + document.documentElement.scrollLeft,
      //       top: domRect.top + document.documentElement.scrollTop - 90,
      //       behavior: "smooth"
      //     });
      //   }
      // });
      if (this.errorDocSize) {
        this.scrollToTop();
      }
      if (!this.errorDocSize && !this.v$.$error) {
        /*  this.ecole.gouvernorat_id.map((item, index) => {
          if (!Number.isInteger(item.governorate_id)) {
            item.governorate_id = item.governorate_id ? item.governorate_id.id : null;
          }
          if (!item.governorate_id) {
            this.ecole.gouvernorat_id.splice(index, 1);
          }
        }); */
        const data = {
          name: this.ecole.name,
          email: this.ecole.email,
          // school_id:this.schoolid,
          phone_number: this.ecole.phone,
          governorate_id: this.selectedGouv,
          delegation_id: this.selectedDeleg,
          zip_code: this.ecole.code_postale,
          address: this.ecole.adresse,
          photo: this.ecole.photo,
          users: this.array,
          modules: this.selected,
          school_categories:this.selectedGat
        };
        SchoolService.create(data)
          .then(() => {
            this.is_created = true;
            this.loading = false;
            this.scrollToTop();
            this.$router.push({ name: "school_list" });
          })
          .then(() => {
            this.$nextTick(() => {
              this.resetFildes();
              //this.student.reset();
              this.v$.$reset();
            });
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.emailSchoolError=this.errors.email;
              this.array.forEach((user, index) => {
                this.array[index].messageErrorEmail = this.errors[`users.${index}.email`];
                this.array[index].messageErrorPhone = this.errors[`users.${index}.phone`];
              });
            }
            this.is_created = false;
            this.loading = false;
            this.scrollToTop();
          });
      } else {
        this.loading = false;
        this.is_created = false;
        this.scrollToTop();
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    ChangeLevel(e) {
      if (e != null) {
        this.classes = this.levels.find((x) => x.id === e).classe;
        // if(this.classes == null){
        //     this.showClass=false
        // } else{
        //     this.showClass=true
        // }
      } else {
        this.classes = [];
      }
      this.student.class_school_id = null;
    },
    onImageChange: function (e) {
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onloadend = (file) => {
        const files = this.$refs.file.files[0];
        this.checkFilesSize(files);
        this.ecole.photo = reader.result;
      };
      reader.readAsDataURL(file);
    },
    onImageReset: function () {
      this.ecole.photo = "";
    },
  },
};
</script>
